import React, { memo, type ReactNode } from 'react';

import { useIsSSROrHydrating } from '@confluence/ssr-utilities/entry-points/useIsSSROrHydrating.ts';

export interface HydrationSafeComponentProps {
	children: ReactNode;
	isEnabled?: boolean;
}

const HydrationSafeComponentContent = memo(
	function HydrationSafeComponentContent({ children }: { isLocked: boolean; children: ReactNode }) {
		return <>{children}</>;
	},
	(_prevProps, nextProps) => {
		// Block updates while locked (during hydration)
		return nextProps.isLocked;
	},
);

export function HydrationSafeComponent({
	children,
	isEnabled = true,
}: HydrationSafeComponentProps): React.JSX.Element {
	const renderServerPlaceholder = useIsSSROrHydrating();

	if (!isEnabled) {
		return <>{children}</>;
	}

	return (
		<HydrationSafeComponentContent isLocked={renderServerPlaceholder}>
			{children}
		</HydrationSafeComponentContent>
	);
}
